<template lang="pug">
login-wrapper(childClass="box-login")
  slot
            legend
              | Войдите в свой аккаунт
              //- span.input-icon
            .form-group(:class="{'has-error': !validation.username}")
              .vfl-field.input-group(style="width: 100%;")
                input(
                    type='text', 
                    v-model='username', 
                    required="", 
                    @focus="validation.username = true",
                    @keyup.enter="onUsernameEnter"
                )
                span.field-underline
                label Номер телефона или email
                    span(v-if='!validation.username', v-html="requiredNotice")
                //- i.fa.fa-user
            .form-group(:class="{'has-error': !validation.password}")
              .vfl-field.input-group(style="width: 100%;")
                input.password(
                    type='password', 
                    v-model='password', 
                    required="", 
                    ref="password",
                    @focus="validation.password = true",
                    @keyup.enter="login"
                )
                span.field-underline
                label Пароль
                    span(v-if='!validation.password', v-html="requiredNotice")
                router-link.forgot(:to="{name: 'Recover'}")
                  | не могу вспомнить
                //- i.fa.fa-lock
            .form-actions
              button.btn.btn-primary.pull-right(@click='login') Войти 
            p.margin-top-20.help-block.error(v-if="errorMessage", v-html="errorMessage")
            p.margin-top-20 Если у Вас ещё нет аккаунта – 
                router-link(:to="{name: 'PrimaryRegistration'}")
                  |  регистрируйтесь скорее
                | .

</template>

<script>
import LoginWrapper from '@/components/auth/LoginWrapper';

export default {
  	name: 'Login',
    components: {
        LoginWrapper
    },
  	methods: {
  	 	  login() {
         if (this.validate()) {
             let params = {
                 username_field: /@/.test(this.username) ? 'email' : 'phone',
                 username: this.username,
                 password: this.password
             };
             this.$store.dispatch('login', params)
                  .catch(({errorMessage, errorCode}) => {
                      this.errorMessage = errorMessage;
                      this.errorCode = errorCode;
                  });
         }
  		  },
      validate() {
          let valid = true;
          for (let field of ['username', 'password']) {
              if (!this[field]) {
                  this.validation[field] = false;
                  valid = false;
              }
          }
          return valid;
      },
        /**
        *   Если пароль заполнен – вызываем ``login``,
        *   иначе – переводим фокус в поле ``password``
        **/
      onUsernameEnter() {
          if (this.password) {
              this.login();
          } else {
              this.$refs.password.focus();
          }
      }
  	},
    data() {
        return {
            username: null,
            password: null,

            requiredNotice: '<b> – обязательно</b>',
            validation: {
                username: true,
                password: true
            },

            errorMessage: null,
            errorCode: null
        };
    }
};
</script>


// WEBPACK FOOTER //
// src/components/auth/Login.vue